import { BLOCKS, MARKS, INLINES, type Node, type Inline, type Table, type Document } from '@contentful/rich-text-types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { useEntryLink } from '@/composables/useEntryLink'

function isInline(node: Node): node is Inline {
  return node.nodeType === INLINES.ENTRY_HYPERLINK || node.nodeType === INLINES.ASSET_HYPERLINK
}

function isTable(node: Node): node is Table {
  return node.nodeType === BLOCKS.TABLE
}

export function richTextConvertorToHtml(
  contentObj: Document,
  replacements?: { [key: string]: string | number },
): string {
  const options = {
    renderNode: {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
      [INLINES.ASSET_HYPERLINK]: (node: Node, next: Function) => {
        if (isInline(node)) {
          return `<a href=${`https:${node.data.target.fields.file.url}`} target=_blank>${next(node.content)}</a>`
        }
        return `<a href=${`https:${node.data.target.fields.file.url}`} target=_blank>${node.data.target.fields.file.fileName}</a>`
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
      [INLINES.ENTRY_HYPERLINK]: (node: Node, next: Function) => {
        if (isInline(node)) {
          return `<a href=${useEntryLink(node.data.target)}>${next(node.content)}</a>`
        }

        return `<a href=${useEntryLink(node.data.target)}>${node.data.target.fields.title}</a>`
      },
      [BLOCKS.EMBEDDED_ASSET]: (node: Node) => {
        const mimeType = ['image/apng', 'image/avif', 'image/gif', 'image/jpeg', 'image/png', 'image/webp']

        const asset = node.data.target

        if (mimeType.includes(node.data.target.fields.file.contentType)) {
          return `<figure class="my-4 g-2">
            <img src="http:${asset.fields.file.url}" alt='${asset.fields.description || ''}' />
          </figure>`
        }

        return ''
      },
      // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
      [BLOCKS.TABLE]: (node: Node, next: Function) => {
        if (isTable(node)) {
          return `<div class="responsive-table my-4"><table>${next(node.content)}</table></div>`
        }

        return ''
      },
    },
    renderMark: {
      [MARKS.CODE]: (text: string) => `<span class="highlight">${text}</span>`,
    },
  }

  let renderedRichtext = documentToHtmlString(contentObj, options)

  if (replacements) {
    Object.keys(replacements).forEach((replacement) => {
      renderedRichtext = renderedRichtext?.replace(`[${replacement}]`, replacements[replacement].toString())
    })
  }

  return renderedRichtext
}

export function richTextConvertorToHtmlLegalNoticeMyself(contentObj: Document) {
  const options = {
    renderMark: {
      [MARKS.CODE]: (text: string) => `<span style="font-size: 18px">${text}</span>`,
      [MARKS.BOLD]: (text: string) => `<span style="font-weight: bold; font-size: 20px">${text}</span>`,
    },
  }

  return documentToHtmlString(contentObj, options)
}
